import React, { useEffect, useState, useContext } from 'react';
import { StoreContext } from '../../../store/Provider';
import { Bar, Chart } from 'react-chartjs-2';


function BarChart(props) {
    const context = useContext(StoreContext);
    let lables = []
    let values = []
    let length1 = 0;
    let length2 = 0;
    let width1 = 0;
    let width2 = 0;
    const [options, setOptions] = useState({});
    if (props.data) {

        if (props.type === "transit") {
            if (props.data.length > 0) {
                lables = Object.keys(props.data[0])
                lables.splice(0, 1)
                lables.splice(0, 1)

                values = Object.values(props.data[0])
                values.splice(0, 1)
                values.splice(0, 1)

            }
        } else {
            props.data.forEach(element => {
                lables.push(element.Key)
                values.push(element.Value)
            });
        }
        if (props.type === 'stats') {
            length2 = props.data.length;
            width2 = 100 + length2 * 40;

        } else if (props.data[0]) {
            length1 = Object.keys(props.data[0]).length - 2;
            width1 = 100 + length1 * 40;
        }
    }



    const data = {
        labels: lables,
        datasets: [
            {
                label: '$',
                data: values,
                backgroundColor: '#122d76',
            }
        ],
    };

    return (
        <div className='bardata'
            style={{
                width: props.type === 'stats' ? width2 : width1, minWidth: '100%'
            }}
        >
            <Bar data={data} options={props.type === 'stats' ? {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        // barPercentage: 0.6,
                        // maxBarThickness: 40,
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                return value.substr(0, 4) + `..`;
                            },
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    mode: 'label',
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.yLabel;
                        },
                        title: function (tooltipItems, data) {
                            var idx = tooltipItems[0].index;
                            return 'Title:' + data.labels[idx];
                        }
                    }
                },
                hover: {
                    "animationDuration": 0
                },
                animation: {
                    // "duration": 1,
                    "onComplete": function () {
                        var chartInstance = this.chart,
                            ctx = chartInstance.ctx;

                        ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';

                        this.data.datasets.forEach(function (dataset, i) {
                            var meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                var data = dataset.data[index];
                                ctx.fillText(data, bar._model.x, bar._model.y);
                            });
                        });
                    }
                },
            } : {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        // barPercentage: 0.6,
                        // maxBarThickness: 40,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    mode: 'label',
                    callbacks: {
                        label: function (tooltipItem) {
                            return `$${context.calculateAmmount(tooltipItem.yLabel)}`;
                        },
                        title: function (tooltipItems, data) {
                            var idx = tooltipItems[0].index;
                            return 'Title : ' + data.labels[idx];
                        }
                    }
                }
            }} />
        </div>

    )
}

export default BarChart
